import compareVersions from 'compare-versions';

export default function sortVersionsDescending(a, b) {
  const semverRegex = /(\d+\.\d+(\.\d+)?)/;
  const aVersionName = semverRegex.exec(a.name)[0];
  const bVersionName = semverRegex.exec(b.name)[0];

  return compareVersions(aVersionName, bVersionName) * -1;
}
